@if (results.length > 0 || isSearching || searchTerm.length > 0) {
  <div class="search-results-dropdown">
    <!-- Filter buttons section -->
    @if (!isSearching && results.length > 0) {
      <div class="filter-buttons-container">
        @for (filter of filterOptions; track filter.type) {
          <button
            type="button"
            class="filter-btn"
            [class.active]="isFilterActive(filter.type)"
            (click)="selectFilter(filter.type)">
            <span class="filter-label">{{ filter.label }}</span>
            <span class="filter-count">({{ filter.count }})</span>
          </button>
        }
      </div>
    }

    <div class="dropdown-content">
      @if (isSearching) {
        <div class="search-loading">
          <div class="spinner"></div>
          <span>Searching...</span>
        </div>
      }

      @if (!isSearching && results.length === 0 && searchTerm.length > 0) {
        <div class="search-no-results">
          <p>No results found for "{{ searchTerm }}"</p>
        </div>
      }

      @if (!isSearching && filteredResults.length > 0) {
        <!-- Show ungrouped results when 'all' filter is selected (maintains backend matched score ordering) -->
        @if (selectedFilter === 'all') {
          @for (result of filteredResults; track result.id) {
            @if (result.type === 'document_model') {
              <div class="result-item result-item-document-model" title="View in fields page" (click)="navigateToEditDocumentModel(result.document_model)">
                <div class="result-main">
                  <div class="result-info">
                    <p class="result-name">{{ result.name }}</p>
                    <span class="result-document-model">{{ result.document_model }}</span>
                    <span class="result-breadcrumb">{{ getPageName(result.type) }}</span>
                  </div>
                </div>
              </div>
            }
            @if (result.type === 'field') {
              <div class="result-item result-item-field" title="View in fields page" (click)="navigateToEditDocumentModel(result.document_model, result.name)">
                <div class="result-main">
                  <div class="result-info">
                    <p class="result-name">{{ result.name }}</p>
                    <span class="result-document-model">{{ result.document_model }}</span>
                  </div>
                </div>
              </div>
            }
          }
        }
        
        <!-- Show grouped results when specific filter is selected -->
        @if (selectedFilter === 'document_model' && documentModelResults.length > 0) {
          <div class="result-group">
            @for (result of documentModelResults; track result.id) {
              <div class="result-item result-item-document-model" title="View in fields page" (click)="navigateToEditDocumentModel(result.document_model)">
                <div class="result-main">
                  <div class="result-info">
                    <p class="result-name">{{ result.name }}</p>
                    <span class="result-document-model">{{ result.document_model }}</span>
                    <span class="result-breadcrumb">{{ getPageName(result.type) }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <!-- Show Fields when Field filter is selected -->
        @if (selectedFilter === 'field' && fieldResults.length > 0) {
          <div class="result-group">
            @for (result of fieldResults; track result.id) {
              <div class="result-item result-item-field" title="View in fields page" (click)="navigateToEditDocumentModel(result.document_model, result.name)">
                <div class="result-main">
                  <div class="result-info">
                    <p class="result-name">{{ result.name }}</p>
                    <span class="result-document-model">{{ result.document_model }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}
